import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { SortDirection } from "@redotech/redo-views-common/table";
import { RedoTableTextCell } from "@redotech/redo-web/arbiter-components/tables/redo-table-cells";
import { ColumnAlignment } from "@redotech/redo-web/table";
import { Column2 } from "@redotech/redo-web/table2";
import { getExpandedItems } from "../../utils/outbound-labels-utils";

const productCustomStringKeys = [
  "productCustomString1",
  "productCustomString2",
  "productCustomString3",
] as const;

export function ProductCustomStringColumn({
  title,
  key,
}: {
  title: string;
  key: (typeof productCustomStringKeys)[number];
}): Column2<FulfillmentGroupData> {
  return {
    alignment: ColumnAlignment.LEFT,
    key,
    title,
    renderNormalCell: ({ row }: { row: FulfillmentGroupData }) => {
      // Collect unique values from all line items
      const values = new Set<string>();
      for (const item of getExpandedItems(row)) {
        const value = item[key];
        if (value) {
          values.add(value);
        }
      }

      return (
        <RedoTableTextCell
          text={values.size > 0 ? Array.from(values).join(", ") : ""}
        />
      );
    },
    renderExpandedCell: ({
      row,
      expansionIndex,
    }: {
      row: FulfillmentGroupData;
      expansionIndex: number;
    }) => {
      const lineItem = getExpandedItems(row)?.[expansionIndex];
      if (!lineItem) {
        return null;
      }
      const value = lineItem[key];
      return <RedoTableTextCell text={value || ""} />;
    },
    width: 120,
    sort: SortDirection.ASC,
  };
}
